import React, { useState } from "react";
import successIcon from '../../assets/icons/importSuccess.svg';
import errorIcon from '../../assets/icons/importError.svg';
import checkIcon from '../../assets/icons/importCheck.svg';
import copyIcon from '../../assets/icons/copyImport.svg';
import deleteIcon from '../../assets/icons/deleteImport.svg';
import {formatDateAndTime} from "../../constants/constants";

const ImportTableComponent = ( props : any) => {
    const [sortConfig, setSortConfig] = useState({ key: "", direction: "asc" });

    const sortData = (key : any) => {
        let direction = "asc";
        if (sortConfig.key === key && sortConfig.direction === "asc") {
            direction = "desc";
        }
        setSortConfig({ key, direction });
    };

    const sortedData = [...props.data].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
            return sortConfig.direction === "asc" ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
            return sortConfig.direction === "asc" ? 1 : -1;
        }
        return 0;
    });

    const getStatusDetails = (status: any) => {
        switch (status) {
            case 0:
                return { label: "Check", color: "bg-[#FFECD2] border border-[#FF9F1C] text-[#FF9F1C] rounded-[4px]", icon: checkIcon };
            case 1:
                return { label: "Success", color: "bg-[#DBEAE2]  border border-[#4C956C] text-[#4C956C] rounded-[4px] ", icon: successIcon };
            case 2:
                return { label: "Error", color: "bg-[#F8D8D6] border border-[#DB3A34] text-[#DB3A34] rounded-[4px]", icon: errorIcon };
            default:
                return { label: "Unknown", color: "bg-gray text-primary" };
        }
    };

    return (
        <div className="overflow-x-auto w-full bg-white">
            <table className="w-full border-collapse">
                <thead>
                <tr className="bg-white border-b border-t text-sm font-light text-primary">
                    {Object.keys(props.data[0]).map((key) => {
                        return(
                        <th key={key} className="px-3 py-2 text-left font-medium cursor-pointer" onClick={() => sortData(key)}>
                            {key.replace(/([A-Z])/g, " $1").replace(/^./, str => str.toUpperCase())}
                            {sortConfig.key === key ? (sortConfig.direction === "asc" ? "↑" : "↓") : ""}
                        </th>
                    )})}
                    {/*<th className="px-3 py-2">Actions</th>*/}
                </tr>
                </thead>
                <tbody>
            {sortedData.map((row, index) => (
                <tr key={index} className="border-b">
                    {Object.keys(row).map((key, idx) => {
                        return (
                            <td key={idx} className="p-4 text-primary text-sm">
                                {key === "status" ? (
                                    <div className={`px-2 py-1 max-w-[105px] flex gap-2 rounded ${getStatusDetails(row[key]).color}`}>
                                        <img src={`${getStatusDetails(row[key]).icon}`} alt=""/>
                                        {getStatusDetails(row[key]).label}
                                    </div>
                                ) : key === "createdAt" ? formatDateAndTime(row[key]) : key === "lastEdit"
                                    ? formatDateAndTime(row[key]) : (
                                    row[key]
                                )}
                            </td>
                        );
                    })}

                    {/*<td className="p-4 flex items-center justify-center">*/}
                    {/*    <button className="mr-2">*/}
                    {/*        <img src={copyIcon} alt="" />*/}
                    {/*    </button>*/}
                    {/*    <button className="text-red-500">*/}
                    {/*    <img src={deleteIcon} alt="" />*/}
                    {/*    </button>*/}
                    {/*</td>*/}
                </tr>
            ))}
            </tbody>
            </table>
        </div>
    );
};

export default ImportTableComponent;